import React from 'react'
import * as UI from 'ui'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import { SelectedDepartmentFilter } from 'support/filters'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { Translation, Translator, useTranslation } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Table } from 'widgets/crud'
import EmploymentSmartview from './employments/smartviews/EmploymentSmartview'
import CurrentEmploymentsHighligtCard from './employments/partials/CurrentEmploymentsHighligtCard'
import SeniorityHighligtCard from './employments/partials/SeniorityHighligtCard'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import { StaticFilter, TriggerPipelineOnConstrain } from '@morningtrain/react-filters'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-helpers'

export default function Employments () {
  const typePlaceholder = useTranslation('hr.employments.filters.type.placeholder')
  const statusPlaceholder = useTranslation('hr.employments.filters.status.placeholder')
  const [includeInactive, setIncludeInactive] = React.useState(false)

  const handleStatusChange = (constraints) => {
    setIncludeInactive(constraints.constraints.focused_status === 'employee_terminated')
  }

  return (
          <AdminPageWithSmartview>
            <Translator namespace="hr.employments">

              {/* Page header */}
              <UI.PageHeader title={<TranslatedTitle name="title"/>}>
                <UI.ButtonWrap>
                  <Can permission={Permissions.EMPLOYMENTS_CREATE_EMPLOYMENT}>
                    <MountSmartviewOnClick smartview={<EmploymentSmartview create/>} replace={false}>
                      <UI.Button color="primary">
                        <Translation name="actions.create"/>
                      </UI.Button>
                    </MountSmartviewOnClick>
                  </Can>
                </UI.ButtonWrap>
              </UI.PageHeader>

              <UI.FlexGrid cols={3} className="mb-5" grow>
                <CurrentEmploymentsHighligtCard/>
                <SeniorityHighligtCard/>
              </UI.FlexGrid>

              <UI.Card>
                <Collection resourceName="employments.employment" operationContext={{ context: 'employment-index' }}>
                  <SelectedDepartmentFilter/>
                  <MountSmartviewOnSelection smartview={<EmploymentSmartview create={false}/>} replace={false}/>

                  {/* Header with filters */}
                  <UI.TableHeader>
                    <Filters.ResourceFilter
                            name="employment_type_id"
                            optionsKey="name"
                            resourceName="employments.employment_type"
                            placeholder={typePlaceholder}
                            label={<Translation name="filters.employment_type.label"/>}
                    />
                    <Pipeline>
                      <TriggerPipelineOnConstrain/>
                      <CallbackOnPipe callback={(e) => handleStatusChange(e)}/>
                    </Pipeline>
                    <Filters.EnumFilter
                            enum="focused_employment_status"
                            name="focused_status"
                            placeholder={statusPlaceholder}
                            label="Status"
                    />
                    <Filters.UserFilter>
                      {includeInactive && (
                              <StaticFilter name={'include_inactive'} value={true}/>
                      )}
                    </Filters.UserFilter>
                  </UI.TableHeader>

                  {/* Crud table with columns */}
                  <Table className="cursor-pointer">
                    <Columns.Text
                            name="user_name"
                            label={<Translation name="columns.user.label"/>}
                    />
                    <Columns.Text
                            name="department_name"
                            label={<Translation name="columns.department.label"/>}
                    />
                    <Columns.Text
                            name="employment_type"
                            label={<Translation name="columns.employment_type.label"/>}
                    />
                    <Columns.Date
                            name="start_at"
                            label={<Translation name="fields.start_at.label"/>}
                    />
                    <Columns.Enum
                            enum="detailed_employment_status"
                            name="detailed_status"
                            label={<Translation name="columns.status.label"/>}
                    />
                  </Table>

                  {/* Footer with pagination */}
                  <Filters.PaginationFilter/>

                </Collection>
        </UI.Card>

      </Translator>
    </AdminPageWithSmartview>
  )
}
